import axios from "axios";
import endpointNames from "../configs/serverUrls";

const baseUrl = endpointNames.files;

const FileDownload = require('js-file-download');


// get User Token
// let user = JSON.parse(localStorage.getItem('user'));
//gets token from localStorage
let token = JSON.parse(localStorage.getItem('token'));

const config = {
    headers: {Authorization: `Bearer ${token}`}
};


const uploadFile = async (file, policyHolderId, policyType) => {
    let response;
    console.log("request: ", file)

    if (policyType === 'ACCIDENT') {
        await axios.post(baseUrl.accidentFileUpload + policyHolderId, file, config)
            .then(res => {
                console.log(res);
                response = res;
            }).catch(err => {
                console.log(err);
                response = err;
            });
    } else if (policyType === 'COMPREHENSIVE') {
        await axios.post(baseUrl.comprehensiveFileUpload + policyHolderId, file, config)
            .then(res => {
                console.log(res);
                response = res;
            }).catch(err => {
                console.log(err);
                response = err;
            });
    } else if (policyType === 'FUNERAL') {
        await axios.post(baseUrl.funeralFileUpload + policyHolderId, file, config)
            .then(res => {
                console.log(res);
                response = res;
            }).catch(err => {
                console.log(err);
                response = err;
            });
    } else if (policyType === 'SAVINGS') {
        await axios.post(baseUrl.savingsFileUpload + policyHolderId, file, config)
            .then(res => {
                console.log(res);
                response = res;
            }).catch(err => {
                console.log(err);
                response = err;
            });
    }
    return response;
}

const accidentUploadFile = async (file, policyHolderId) => {
    let response;
    await axios.post(baseUrl.accidentFileUpload + policyHolderId, file, config)
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const funeralUploadFile = async (file, policyHolderId) => {
    let response;
    await axios.post(baseUrl.funeralFileUpload + policyHolderId, file, config)
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const savingsUploadFile = async (file, policyHolderId) => {
    let response;

    await axios.post(baseUrl.savingsFileUpload + policyHolderId, file, config)
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const comprehensiveUploadFile = async (file, policyHolderId) => {
    let response;
    await axios.post(baseUrl.comprehensiveFileUpload + policyHolderId, file, config)
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

/***
 *Download functions
 */

const accidentDownloadFile = async (policyHolderId, request) => {
    let response;
    console.log(config)
    await axios.get(baseUrl.accidentFileDownload + policyHolderId, {
        headers: {Authorization: `Bearer ${token}`},
        params: {
            fileName: request.fileName,
            file_url: request.file_url,
        },
        responseType: "blob"
    })
        .then(res => {
            console.log(res);
            FileDownload(res.data, res.config.params.fileName + "-" + res.config.params.file_url);
            response = "Download successfull";
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const funeralDownloadFile = async (policyHolderId, request) => {
    let response;


    await axios.get(baseUrl.funeralFileDownload + policyHolderId, {
        headers: {Authorization: `Bearer ${token}`},
        params: {
            fileName: request.fileName,
            file_url: request.file_url,
        },
        responseType: "blob"
    })
        .then(res => {
            console.log(res);
            FileDownload(res.data, res.config.params.fileName + "-" + res.config.params.file_url);
            response = "Download successfull";
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const savingsDownloadFile = async (policyHolderId, request) => {
    let response;
    console.log("request: " + request);
    await axios.get(baseUrl.savingsFileDownload + policyHolderId, {
        headers: {Authorization: `Bearer ${token}`},
        params: {
            fileName: request.fileName,
            file_url: request.file_url,
        },
        responseType: "blob"
    })
        .then(res => {
            console.log(res);
            FileDownload(res.data, res.config.params.fileName + "-" + res.config.params.file_url);
            response = "Download successfull";
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const comprehensiveDownloadFile = async (policyHolderId, request) => {
    let response;
    await axios.get(baseUrl.comprehensiveFileDownload + policyHolderId, {
        headers: {Authorization: `Bearer ${token}`},
        params: {
            fileName: request.fileName,
            file_url: request.file_url,
        },
        responseType: "blob"
    })
        .then(res => {
            console.log(res);
            FileDownload(res.data, res.config.params.fileName + "-" + res.config.params.file_url);
            response = "Download successfull";
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}
/****
 * End download functions
 */



const downloadInvoice = async (paymentId) => {
    let response;
    await axios.get(baseUrl.downloadInvoice + paymentId, {
        headers: {Authorization: `Bearer ${token}`},
        responseType: "blob"
    })
        .then(res => {
            console.log(res.data);
            FileDownload(res.data);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}


const downloadFile = async (filename) => {
    let response;
    await axios.get(baseUrl.fileDownload + filename)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const updateFile = async (file, filename) => {
    let response;
    await axios.post(baseUrl.fileUpdate)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

/***
 * Bulk Payments Import
 */
const bulkPaymentImport = async (request, aggregator_id) => {
    let response;
    console.log('req: ' + request)
    await axios.post(baseUrl.bulkPayments + aggregator_id, request, config)
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}


//    claim file endpoints
const injuryClaimUpload = async (file) => {
    let response;
    await axios.post(baseUrl.injuryClaimUpload, file, config)
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const deathClaimUpload = async (file) => {
    let response;
    await axios.post(baseUrl.deathClaimUpload, file, config)
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const comprehensiveClaimUpload = async (file) => {
    let response;
    await axios.post(baseUrl.comprehensiveClaimUpload, file, config)
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const funeralClaimUpload = async (file) => {
    let response;
    await axios.post(baseUrl.funeralClaimUpload, file, config)
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const savingsSurrenderUpload = async (file) => {
    let response;
    await axios.post(baseUrl.savingSurrenderUpload, file, config)
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const savingsRefundUpload = async (file) => {
    let response;
    await axios.post(baseUrl.savingRefundUpload, file, config)
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const savingsWithdrawalUpload = async (file) => {
    let response;
    await axios.post(baseUrl.savingWithdrawUpload, file, config)
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const savingsDeathUpload = async (file) => {
    let response;
    await axios.post(baseUrl.savingDeathClaimUpload, file, config)
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//download
const comprehensiveClaimDownload = async (id) => {
    let response;
    await axios.get(baseUrl.comprehensiveClaimDownload + id, {
        headers: {Authorization: `Bearer ${token}`},
        responseType: "blob"
    })
        .then(res => {
            console.log(res);

            console.log("url", res.config.url);
            window.open(res.config.url, '_blank');
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const funeralClaimDownload = async (id) => {
    let response;
    await axios.get(baseUrl.funeralClaimDownload + id, {
        headers: {Authorization: `Bearer ${token}`},
        responseType: "blob"
    })
        .then(res => {
            console.log(res);
            console.log("url", res.config.url);
            window.open(res.config.url, '_blank');
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const savingsSurrenderDownload = async (id) => {
    let response;
    await axios.get(baseUrl.savingsSurrenderDownload + id, {
        headers: {Authorization: `Bearer ${token}`},
        responseType: "blob"
    })
        .then(res => {
            console.log("response: ", res);
            console.log("url", res.config.url);
            window.open(res.config.url, '_blank');
            response = res;
        }).catch(err => {
            console.log("error ", err);
            response = err;
        });
    return response;
}

const savingsRefundDownload = async (id) => {
    let response;
    await axios.get(baseUrl.savingRefundDownload + id, {
        headers: {Authorization: `Bearer ${token}`},
        responseType: "blob"
    })
        .then(res => {
            console.log(res);
            console.log("url", res.config.url);
            window.open(res.config.url, '_blank');
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const savingsWithdrawalDownload = async (id) => {
    let response;
    await axios.get(baseUrl.savingWithdrawDownload + id, {
        headers: {Authorization: `Bearer ${token}`},
        responseType: "blob"
    })
        .then(res => {
            console.log(res);
            console.log("url", res.config.url);
            window.open(res.config.url, '_blank');
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const savingsDeathDownload = async (id) => {
    let response;
    await axios.get(baseUrl.savingDeathClaimDownload + id, {
        headers: {Authorization: `Bearer ${token}`},
        responseType: "blob"
    })
        .then(res => {
            console.log(res);
            console.log("url", res.config.url);
            window.open(res.config.url, '_blank');
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const deathClaimDownload = async (id) => {
    let response;
    await axios.get(baseUrl.deathClaimDownload + id, {
        headers: {Authorization: `Bearer ${token}`},
        responseType: "blob"
    })
        .then(res => {
            console.log(res);
            console.log("url", res.config.url);
            window.open(res.config.url, '_blank');
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const injuryClaimDownload = async (id) => {
    let response;
    await axios.get(baseUrl.injuryClaimDownload + id, {
        headers: {Authorization: `Bearer ${token}`},
        responseType: "blob"
    })
        .then(res => {
            console.log(res);
            console.log("url", res.config.url);
            window.open(res.config.url, '_blank');
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}


export default {
    downloadFile,
    downloadInvoice,
    updateFile,
    uploadFile,
    accidentUploadFile,
    comprehensiveUploadFile,
    savingsUploadFile,
    funeralUploadFile,
    accidentDownloadFile,
    savingsDownloadFile,
    funeralDownloadFile,
    comprehensiveDownloadFile,
    bulkPaymentImport,
    comprehensiveClaimUpload,
    comprehensiveClaimDownload,
    funeralClaimUpload,
    funeralClaimDownload,
    savingsDeathUpload,
    savingsSurrenderUpload,
    savingsRefundUpload,
    savingsWithdrawalUpload,
    savingsSurrenderDownload,
    savingsWithdrawalDownload,
    savingsRefundDownload,
    savingsDeathDownload,
    injuryClaimUpload, deathClaimUpload, injuryClaimDownload, deathClaimDownload

}
